import React from 'react';
import ReactDOM from 'react-dom';
import CheckboxList from './FilterTypes/CheckboxList.jsx';
import RadioList from './FilterTypes/RadioList.jsx';
import SearchableCheckboxList from './FilterTypes/SearchableCheckboxList.jsx';
import RangeSliderComponent from './FilterTypes/RangeSliderComponent.jsx';
import LocationFilter from './FilterTypes/LocationFilter.jsx';
import NameFilter from './FilterTypes/NameFilter.jsx';
import FilterWrapper from './FilterTypes/FilterWrapper.jsx';
import DateFilter from './FilterTypes/DateFilter.jsx';

class Filters extends React.Component {
  constructor(props) {
    super(props);
    this._nominalDistancesUpdate = this._nominalDistancesUpdate.bind(this);
    this._organizerUpdate = this._organizerUpdate.bind(this);
    this._getQuery = this._getQuery.bind(this);
    this._locationFilterUpdate = this._locationFilterUpdate.bind(this);
    this._updateTextQuery = this._updateTextQuery.bind(this);
    this._aaaFilterUpdate = this._aaaFilterUpdate.bind(this);
    this._popFilterUpdate = this._popFilterUpdate.bind(this);
    this._clearFilters = this._clearFilters.bind(this);
    this._updateDateFilter = this._updateDateFilter.bind(this);
    this._updateCategory = this._updateCategory.bind(this);
    this._statusUpdate = this._statusUpdate.bind(this);
    this.submit = this.submit.bind(this);

  }
  _getQuery() {
    return JSON.parse(JSON.stringify(this.props.query));
  }
  _nominalDistancesUpdate(min, max) {
    var model = this._getQuery();
    model.NominalDistanceMin = min;
    model.NominalDistanceMax = max;
    this.submit(model);
  }
  _organizerUpdate(organizers) {
    var model = this._getQuery();
    model.Organizers = organizers;
    this.submit(model);
  }
  _statusUpdate(status) {
    var model = this._getQuery();
    model.Status = status;
    this.submit(model);
  } 
   _updateCategory(category) {
    var model = this._getQuery();
    model.Category = category;
    this.submit(model);
  }
  _aaaFilterUpdate(filter) {
    var model = this._getQuery();
    model.AAA = filter;
    this.submit(model);
  }
  _popFilterUpdate(filter) {
    var model = this._getQuery();
    model.PoP = filter;
    this.submit(model);
  }
  _updateDateFilter(filter) {
    var model = this._getQuery();
    model.Date = filter;
    this.submit(model);
  }
  _locationFilterUpdate(type, postcode, locationLat, locationLng, distance) {
    var model = this._getQuery();
    model.LocationType = type;
    model.LocationPostcode = postcode;
    model.LocationLocalityLat = locationLat;
    model.LocationLocalityLng = locationLng;
    model.LocationDistance = distance;
    this.submit(model);
  }
  _updateTextQuery(text) {
    console.log("_updateTextQuery", text);
    var model = this._getQuery();
    model.Query = text;
    this.submit(model);
  }
  submit(model) {
    model.Page = 1;

    this.props.onChange(model);
  }
  _clearFilters(e) {
    var model = this._getQuery();
    model.Query = null;
    model.Organizers = null;
    model.NominalDistanceMin = null;
    model.NominalDistanceMax = null;
    model.LocationType = null;
    model.LocationPostcode = null;
    model.LocationLocalityLng = null;
    model.LocationLocalityLat = null;
    model.LocationDistance = null;
    model.LocationPostcodeGeocoded = null;
    model.Date = null;
    model.AAA = null;
    model.PoP = null;

    model.Status = ["Ready"];

    this.submit(model);
  }

  /* 
      <RadioList title="AAA Events" />       
*/
  render() {
    var isCalendarEvents = this.props.eventType == "calendarEvents";
    var isPermEvents = this.props.eventType == "permanentEvents";

    return (<>
      {isCalendarEvents && (
        <FilterWrapper title="Date">
          <DateFilter onChange={this._updateDateFilter} selected={this.props.query.Date} availableDates={this.props.facetData.EventDates} />
        </FilterWrapper>
      )}
      <FilterWrapper title="Search">
        <NameFilter onChange={this._updateTextQuery} query={this.props.query.Query} />
      </FilterWrapper>
      <FilterWrapper title="Organizer">
        <SearchableCheckboxList options={this.props.facetData.Organizers} onChange={this._organizerUpdate} selected={this.props.query.Organizers} />
      </FilterWrapper>

      <FilterWrapper title="Location">
        <LocationFilter onChange={this._locationFilterUpdate} query={this.props.query} selectedFilterType={this.props.query.LocationType} selectedPostcode={this.props.query.LocationPostcode} />
      </FilterWrapper>

      <FilterWrapper title="Distances">
        <RangeSliderComponent options={this.props.facetData.NominalDistances} onChange={this._nominalDistancesUpdate} selectedMaximum={this.props.query.NominalDistanceMax} selectedMinimum={this.props.query.NominalDistanceMin} />
      </FilterWrapper>

      <FilterWrapper title="AAA">
        <RadioList options={this.props.facetData.AAAOptions} onChange={this._aaaFilterUpdate} radioGroupName="aaa" />
      </FilterWrapper>
      {isCalendarEvents && (
        <FilterWrapper title="Category">
          <CheckboxList options={this.props.facetData.Categories} onChange={this._updateCategory} selected={this.props.query.Category} />
        </FilterWrapper>
      )}
      {isPermEvents && (
        <FilterWrapper title="Proof of Passage">
          <RadioList options={this.props.facetData.PoPOptions} onChange={this._popFilterUpdate} radioGroupName="pop" />
        </FilterWrapper>
      )}
      {isPermEvents && (
        <FilterWrapper title="Status">
          <CheckboxList options={this.props.facetData.Status} onChange={this._statusUpdate} selected={this.props.query.Status} />
        </FilterWrapper>
      )}
      <FilterWrapper title="">
        <a href="#" onClick={this._clearFilters} className="btn btn-primary btn-sm">Clear</a>
      </FilterWrapper>
    </>
    );
  }
}
export default Filters;


